import { XStack } from 'tamagui';

import { Chip } from '@/components/category-chip';
import { AGE_RANGES } from '@/lib/age-range';

// Single-select row of age-band chips -- same selectable-pill pattern
// CategoryChip already established (the shared Chip), reused here rather than inventing a
// second selection idiom for what is structurally the same interaction
// (pick one of a small fixed set). No "All"/unset option rendered
// inline -- a band already selected can be cleared by tapping it again
// (the same toggle-off behavior VoteControl's press('up')/press('down')
// already uses for "tap the active one to remove it").
export function AgeRangePicker({ value, onValueChange }: { value: string; onValueChange: (next: string) => void }) {
  return (
    <XStack flexWrap="wrap" gap="$2">
      {AGE_RANGES.map((band) => (
        <Chip
          key={band}
          label={band}
          selected={value === band}
          onPress={() => onValueChange(value === band ? '' : band)}
        />
      ))}
    </XStack>
  );
}
